export const getConfig = key => {
  if (window[key]) {
    return window[key];
  } else if (process.env[key]) {
    return process.env[key];
  } else {
    throw new Error(`Key ${key} not found in any of the valid config sources.`);
  }
};
